// extracted by mini-css-extract-plugin
module.exports = {"back":"BackButton_back__2QDFQ"};